import router from '@/router';
import axios from '../../mixins/global_mounted/apiRequest';

const getDefaultState = () => {
    return {
        organs: [],
        penyakits: [],
        pasien: {},
        postData: {},
        postDataLoaded: false,
        transaksi: {},
        errorSyncMsg: "",
        canvas_pemeriksaan: null,
        canvas_diagnosa: null,
        canvas_anamnesa: null,
        canvas_keluhan: null,
        canvas_tatalaksana: null,
        canvas_pemeriksaan_penunjang: null,
        canvas_odontogram: null,
        saving_params: {
            is_email: false,
            is_number: false,
            is_saving: false,
            is_saved: false,
            is_agree: false,
            is_next_konsul: false,
            is_reminder: false,
            is_kuotanotnull: false,
            is_email_format: true,
            is_selesai: false,
            is_bpjs: false,
            is_poli_gigi: false,
        },
        kesadaran: {
            options: [],
            selected: null,
        },
        status_pulang: {
            options: [],
            selected: null,
        },
    }
};

const checkPoliGigi = (poli) => {
    if (poli && poli != undefined) {
        if (poli.toLowerCase().includes('gigi') || poli.toLowerCase().includes('dental')) return true;
    }
    return false;
}

const state = getDefaultState();

const getters = {
    trx: state => state.transaksi,
    error_sync_msg: state => state.errorSyncMsg,
    pasien: state => state.pasien,
    organs: state => state.organs,
    postData: state => state.postData,
    postDataLoaded: state => state.postDataLoaded,
    canvas_pemeriksaan: state => state.canvas_pemeriksaan,
    canvas_diagnosa: state => state.canvas_diagnosa,
    canvas_anamnesa: state => state.canvas_anamnesa,
    canvas_keluhan: state => state.canvas_keluhan,
    canvas_tatalaksana: state => state.canvas_tatalaksana,
    canvas_pemeriksaan_penunjang: state => state.canvas_pemeriksaan_penunjang,
    saving_params: state => state.saving_params,
    kesadaran: state => state.kesadaran,
    status_pulang: state => state.status_pulang,
};

const actions = {
    // call at the first time to reset the state
    resetState({ commit }) {
        commit('resetState')
    },

    // get initial data from backend
    async fetchData({ commit, dispatch }, value = null) {
        dispatch('resetState');

        const pasien_id = router.currentRoute.params.pasien_id;
        const transklinik_id = router.currentRoute.params.transklinik_id;

        let resPasien
        if(value != null) {
            let withParentQS = '';  
            if(localStorage.getItem('with_parent') == 1){
                withParentQS = '&with_parent=1';
            }
            // get pasien data (Tensi, BB, TB, Respirasi, Sistole, Diastole)
            const res_pasien = await axios.get(`pasien/${pasien_id}?klinik_id=${value}&id=${pasien_id}${withParentQS}`);
            resPasien = res_pasien.data
            commit('setPasien', resPasien)

            // set postData
            commit('setPostData', { key: "anamnesa_text", value: resPasien.data.anamnesa });
        } else {
            // get pasien data (Tensi, BB, TB, Respirasi, Sistole, Diastole)
            const res_pasien = await axios.get(`pasien/${pasien_id}`);
            resPasien = res_pasien.data
            commit('setPasien', resPasien)
        }
        if (resPasien) {
            commit('editSetPostData', [
                // tanda vital
                { key: "berat_badan", value: resPasien.data.berat_badan },
                { key: "tinggi_badan", value: resPasien.data.tinggi_badan },
                { key: "imt", value: resPasien.data.imt },
                { key: "nadi", value: resPasien.data.nadi },
                { key: "respirasi", value: resPasien.data.respirasi },
                { key: "suhu", value: resPasien.data.suhu },
                { key: "tensi_diastole", value: resPasien.data.tensi_diastole },
                { key: "tensi_sistole", value: resPasien.data.tensi_sistole },
                { key: "lingkar_perut", value: resPasien.data.lingkar_perut },
                { key: "saturasi_oksigen", value: resPasien.data.saturasi_oksigen },
                { key: "golongan_darah", value: resPasien.data.golongan_darah },
                { key: "keluhan", value: resPasien.data.keluhan },
                { key: "riwayat_penyakit", value: resPasien.data.riwayat_penyakit },
                { key: "riwayat_alergi_obat", value: resPasien.data.riwayat_alergi_obat },
                { key: "ket_riwayat_alergi_obat", value: resPasien.data.ket_riwayat_alergi_obat },
                { key: "riwayat_alergi_makanan", value: resPasien.data.riwayat_alergi_makanan },
                { key: "ket_riwayat_alergi_makanan", value: resPasien.data.ket_riwayat_alergi_makanan },
                { key: "riwayat_alergi_udara", value: resPasien.data.riwayat_alergi_udara },
                { key: "riwayat_alergi_lain", value: resPasien.data.riwayat_alergi_lain },
                { key: "riwayat_pengobatan", value: resPasien.data.riwayat_pengobatan },
                { key: "keterangan_lain", value: resPasien.data.keterangan_lain },
                { key: "alergi_obat_bpjs", value: resPasien.data.alergi_obat_bpjs },
                { key: "alergi_makanan_bpjs", value: resPasien.data.alergi_makanan_bpjs },
                { key: "alergi_udara_bpjs", value: resPasien.data.alergi_udara_bpjs },
            ]);
        }

        const rmId = localStorage.getItem("rekam_medis_id")
        let is_bpjs = false, kdSadar = null, kdStatusPulang = null;
        if(rmId == null) {
            // update transklinik (antrean) status to "KONSULTASI"
            const TransStatus = await axios.put(
                "/transaksi/" + transklinik_id, {
                status: 'KONSULTASI'
            });
            is_bpjs = TransStatus.data.data.kategori_id == 2

            commit('setPostData', { key: "poli_id", value: TransStatus.data.data.poli_id });
            commit('setPostData', { key: "dokter_id", value: TransStatus.data.data.dokter_id });
            commit('setTransaksi', TransStatus.data.data);
            if (TransStatus.data.data && TransStatus.data.data.poli_name) {
                if (checkPoliGigi(TransStatus.data.data.poli_name)) commit('setIsSaving', { key: "is_poli_gigi", value: true });
                else commit('setIsSaving', { key: "is_poli_gigi", value: false });
            } else {
                commit('setIsSaving', { key: "is_poli_gigi", value: false });
            }
        } else {

            const rm = await axios.get(`rekam_medis/${rmId}?id=${rmId}`)
            const { status, data, rujukan } = rm.data
            if (status) {
                const TransStatus = await axios.put(
                    "/transaksi/" + transklinik_id, {
                    status: data.transklinik.status
                });
                is_bpjs = TransStatus.data.data.kategori_id == 2
                commit('setPostData', { key: "poli_id", value: TransStatus.data.data.poli_id });
                commit('setPostData', { key: "dokter_id", value: TransStatus.data.data.dokter_id });
                if (is_bpjs && rujukan) {
                    commit('editSetPostData', [
                        { key: "tanggal_rujuk", value: rujukan.tglRencanaBerkunjung || null },
                        { key: "kdppk", value: rujukan.kdppk || null },
                    ]);
                    if (rujukan.ref_khusus) {
                        commit('editSetPostData', [
                            { key: "kdKhusus", value: rujukan.ref_khusus ? rujukan.ref_khusus.kdKhusus : null },
                            { key: "kdKhususSubSpesialis", value: rujukan.subSpesialis_khusus ? rujukan.subSpesialis_khusus.kdSubSpesialis : null },
                            { key: "note_khusus", value: rujukan.catatan || null },
                        ]);
                    }
                    if (rujukan.subSpesialis_spesialis) {
                        commit('editSetPostData', [
                            { key: "kdSpesialis", value: rujukan.ref_khusus ? rujukan.ref_khusus.kdKhusus : null },
                            { key: "kdSubSpesialis", value: rujukan.subSpesialis_spesialis ? rujukan.subSpesialis_spesialis.kdSubSpesialis : null },
                            { key: "kdSarana", value: rujukan.kdSarana || null },
                        ]);
                    }
                }
                commit('setTransaksi', TransStatus.data.data);
                if (TransStatus.data.data && TransStatus.data.data.poli_name) {
                    if (checkPoliGigi(TransStatus.data.data.poli_name)) commit('setIsSaving', { key: "is_poli_gigi", value: true });
                    else commit('setIsSaving', { key: "is_poli_gigi", value: false });
                } else {
                    commit('setIsSaving', { key: "is_poli_gigi", value: false });
                }
                
                localStorage.setItem("edit_rekam_medis", JSON.stringify(data))
                localStorage.setItem("edit_rujukan", JSON.stringify(rujukan))
                if (localStorage.getItem("rm_reload") == "true") {
                    localStorage.setItem("rm_reload", false)
                    window.location.reload()
                }
                if (data.anamnesa) {
                    resPasien = {
                        data: {
                            ...resPasien.data,
                            berat_badan: data.anamnesa.berat_badan,
                            tinggi_badan: data.anamnesa.tinggi_badan,
                            imt: data.anamnesa.imt,
                            nadi: data.anamnesa.nadi,
                            respirasi: data.anamnesa.respirasi,
                            suhu: data.anamnesa.suhu,
                            tensi_diastole: data.anamnesa.tensi_diastole,
                            tensi_sistole: data.anamnesa.tensi_sistole,
                            lingkar_perut: data.anamnesa.lingkar_perut,
                            keluhan: data.anamnesa.keluhan,
                            riwayat_penyakit: data.anamnesa.riwayat_penyakit,
                            riwayat_alergi_obat: data.anamnesa.riwayat_alergi_obat,
                            ket_riwayat_alergi_obat: data.anamnesa.ket_riwayat_alergi_obat,
                            riwayat_alergi_makanan: data.anamnesa.riwayat_alergi_makanan,
                            ket_riwayat_alergi_makanan: data.anamnesa.ket_riwayat_alergi_makanan,
                            riwayat_alergi_udara: data.anamnesa.riwayat_alergi_udara,
                            riwayat_alergi_lain: data.anamnesa.riwayat_alergi_lain,
                            riwayat_pengobatan: data.anamnesa.riwayat_pengobatan,
                            alergi_obat_bpjs: data.anamnesa.alergi_obat_bpjs,
                            alergi_makanan_bpjs: data.anamnesa.alergi_makanan_bpjs,
                            alergi_udara_bpjs: data.anamnesa.alergi_udara_bpjs,
                        }
                    }

                    // edit set postData
                    commit('editSetPostData', [    
                        // tanda vital
                        { key: "berat_badan", value: data.anamnesa.berat_badan },
                        { key: "tinggi_badan", value: data.anamnesa.tinggi_badan },
                        { key: "imt", value: data.anamnesa.imt },
                        { key: "nadi", value: data.anamnesa.nadi },
                        { key: "respirasi", value: data.anamnesa.respirasi },
                        { key: "suhu", value: data.anamnesa.suhu },
                        { key: "tensi_diastole", value: data.anamnesa.tensi_diastole },
                        { key: "tensi_sistole", value: data.anamnesa.tensi_sistole },
                        { key: "lingkar_perut", value: data.anamnesa.lingkar_perut },
                        { key: "keluhan", value: data.anamnesa.keluhan },
                        { key: "riwayat_penyakit", value: data.anamnesa.riwayat_penyakit },
                        { key: "riwayat_alergi_obat", value: data.anamnesa.riwayat_alergi_obat },
                        { key: "ket_riwayat_alergi_obat", value: data.anamnesa.ket_riwayat_alergi_obat },
                        { key: "riwayat_alergi_makanan", value: data.anamnesa.riwayat_alergi_makanan },
                        { key: "ket_riwayat_alergi_makanan", value: data.anamnesa.ket_riwayat_alergi_makanan },
                        { key: "riwayat_alergi_udara", value: data.anamnesa.riwayat_alergi_udara },
                        { key: "riwayat_alergi_lain", value: data.anamnesa.riwayat_alergi_lain },
                        { key: "riwayat_pengobatan", value: data.anamnesa.riwayat_pengobatan },
                        { key: "alergi_obat_bpjs", value: data.anamnesa.alergi_obat_bpjs },
                        { key: "alergi_makanan_bpjs", value: data.anamnesa.alergi_makanan_bpjs },
                        { key: "alergi_udara_bpjs", value: data.anamnesa.alergi_udara_bpjs },
                    ])
                }

                let tatalaksana = []
                if(data.transklinik.pembayaran.length > 0) {
                    data.transklinik.pembayaran.map(p => {
                        if(p.detail.length > 0) {
                            tatalaksana = [
                                ...p.detail.map(item => {
                                    let stock = null;
                                    if (item.layanan) {
                                      if (item.layanan.stok == 0) stock = 0;
                                      else stock = item.layanan.stok;
                                    }
                                    let kategori_layanan = item.layanan && item.layanan.kategori_layanan && item.layanan.kategori_layanan.nama ? item.layanan.kategori_layanan.nama : '-';
                                    return {
                                        ...item,
                                        stok: stock,
                                        kategori_layanan: kategori_layanan,
                                    }
                                })
                            ]
                        }
                    })
                }
                // edit set postData
                commit('editSetPostData', [
                    { key: "rekam_medis_id", value: data.id },
                    { key: "anamnesa_id", value: data.anamnesa_id },
                    { key: "pemeriksaan_fisik_id", value: data.pemeriksaan_fisik_id },
                    { key: "diagnosa_id", value: data.diagnosa_id },
                    { key: "transklinik_id", value: data.transklinik_id },
                    { key: "tata_laksana_id", value: data.tata_laksana_id },
                    { key: "pemeriksaan_penunjang_id", value: data.pemeriksaan_penunjang_id },
                    { key: "pembayaran_id", value: data.transklinik && data.transklinik.pembayaran.length > 0 ? data.transklinik.pembayaran[0].id : null },
                    { key: "bpjs_mcu_id", value: data.bpjs_mcu_id },

                    // anamnesa
                    { key: "anamnesa_text", value: data.anamnesa ? data.anamnesa.notes : null },
                    { key: "kd_prognosa", value: data.bpjs_health_data ? data.bpjs_health_data.kd_prognosa : null },

                    // pemeriksaan fisik
                    { key: "organ_id", value: data.pemeriksaan_fisik ? data.pemeriksaan_fisik.organ_id : null },
                    { key: "pemeriksaan_text", value: data.pemeriksaan_fisik ? data.pemeriksaan_fisik.notes : null },
                    { key: "tingkat_kesadaran", value: data.pemeriksaan_fisik ? data.pemeriksaan_fisik.tingkat_kesadaran : null },

                    // diagnosa
                    { key: "diagnosa_text", value: data.diagnosa ? data.diagnosa.notes : null },

                    // tatalaksana
                    { key: "tatalaksana_text", value: data.tatalaksana ? data.tatalaksana.notes : null },
                    { key: "tatalaksana", value: data.transklinik.pembayaran.length > 0 ? tatalaksana : [] },
                    { key: "terapi_obat", value: data.bpjs_health_data ? data.bpjs_health_data.terapi_obat : null },
                    { key: "terapi_non_obat", value: data.bpjs_health_data ? data.bpjs_health_data.terapi_non_obat : null },
                    { key: "bmhp", value: data.bpjs_health_data ? data.bpjs_health_data.bmhp : null },

                    // pemeriksaan_penunjang
                    { key: "pemeriksaan_penunjang", value: data.pemeriksaan_penunjang && data.pemeriksaan_penunjang.files ? JSON.parse(data.pemeriksaan_penunjang.files) : null },
                    { key: "pemeriksaan_penunjang_text", value: data.pemeriksaan_penunjang ? data.pemeriksaan_penunjang.notes : null },
                    { key: "jenis_pemeriksaan", value: data.bpjs_mcu ? data.bpjs_mcu.data : [] },

                    // next konsultasi
                    { key: "next_konsultasi", value: data.transklinik.next_konsultasi },
                    { key: "tgl_next_konsultasi", value: data.transklinik.tgl_next_konsultasi != "1970-01-01" ? data.transklinik.tgl_next_konsultasi : "1970-01-01" },

                    // for bpjs
                    { key: "kdSadar", value: data.bpjs_kdSadar },
                    { key: "kdStatusPulang", value: data.bpjs_kdStatusPulang },
                    { key: "kd_tacc", value: data.bpjs_health_data ? data.bpjs_health_data.kd_tacc : null },
                    { key: "alasan_tacc", value: data.bpjs_health_data ? data.bpjs_health_data.alasan_tacc : null },
                ])
                if (data.pasien.email_reminder == 1) {
                    commit('setPostData', { key: "email_konsultasi", value: data.pasien.email })
                }
                kdSadar = data.bpjs_kdSadar
                kdStatusPulang = data.bpjs_kdStatusPulang
                if(data.transklinik.durasi_konsultasi != 99) commit('setIsSaving', { key: 'is_next_konsul', value: true });
            }
        }
        commit('setPasien', resPasien);
        if (is_bpjs) {
            commit('setIsSaving', { key: 'is_bpjs', value: true });
            
            const kesadaran = await axios.get(`bpjs/kesadaran?klinik_id=${value}`);
            if (kesadaran.data.metaData.code == 200 && kesadaran.data.response) {
                const dataKesadaran = kesadaran.data.response.list.map((item) => ({
                    value: item.kdSadar,
                    label: item.nmSadar,
                }));
                commit('setKesadaran', {key: 'options', value: dataKesadaran })
                commit('setKesadaran', {key: 'selected', value: dataKesadaran.find((item) => item.value == kdSadar) })
            }
            
            const status_pulang = await axios.get(`bpjs/status-pulang?rawat_inap=false&klinik_id=${value}`);
            if (status_pulang.data.metaData.code == 200 && status_pulang.data.response) {
                const dataStatusPulang = status_pulang.data.response.list.map((item) => ({
                    value: item.kdStatusPulang,
                    label: item.nmStatusPulang,
                }));
                commit('setStatusPulang', {key: 'options', value: dataStatusPulang })
                commit('setStatusPulang', {key: 'selected', value: dataStatusPulang.find((item) => item.value == kdStatusPulang) })
            }
        }
        commit('setPostDataLoaded', true); 
    },

    // this function called from TandaVital.vue
    updateTandaVital({ commit }, payload) {
        commit('setPostData', payload);
    },
    updatePasien({ commit }, payload) {
        commit('setPasien', payload);
    },

    // preparing the payload to send to backend
    updatePostData({ commit, state }, payload) {
        commit('setPostData', payload);
    },

    // this function called on canvas changed
    updateCanvas({ commit }, payload) {
        commit('setCanvas', payload);
    },

    // this function to update (next konsul & agreement)
    updateSavingParams({ commit }, payload) {
        commit('setIsSaving', payload);
    },

    updatePostDataKlinik({ commit }, payload) {
        payload.map(item => {
            commit('setPostData', {
                key: item.key,
                value: item.value
            });
        })
    },

    // for bpjs
    updateKesadaran({ commit }, payload) {
        commit('setKesadaran', payload);
    },
    updateStatusPulang({ commit }, payload) {
        commit('setStatusPulang', payload);
    },

    //saving rekam medis
    async saveRekamMedis({ commit, state }, is_klinik = false) {
        // get pasien_id and transklinik_id from the route
        const pasien_id = router.currentRoute.params.pasien_id;
        const transklinik_id = router.currentRoute.params.transklinik_id;

        state.postData['transklinik_id'] = transklinik_id;
        state.postData['pasien_id'] = pasien_id;

        // if canvas is draw, send to backend
        // start
        if (state.postData['anamnesa_is_draw']) {
            state.postData['anamnesa_draw'] = state.canvas_anamnesa.toDataURL("image/png");
        }

        if (state.postData['keluhan_is_draw']) {
            state.postData['keluhan_draw'] = state.canvas_keluhan.toDataURL("image/png");
        }

        if (state.postData['pemeriksaan_is_draw']) {
            state.postData['pemeriksaan_draw'] = state.canvas_pemeriksaan.toDataURL("image/png");
        }

        if (state.postData['diagnosa_is_draw']) {
            state.postData['diagnosa_draw'] = state.canvas_diagnosa.toDataURL("image/png");
        }

        if (state.postData['tatalaksana_is_draw']) {
            state.postData['tatalaksana_draw'] = state.canvas_tatalaksana.toDataURL("image/png");
        }

        if (state.postData['pemeriksaan_penunjang_is_draw']) {
            state.postData['pemeriksaan_penunjang_draw'] = state.canvas_pemeriksaan_penunjang.toDataURL("image/png");
        }

        if (state.postData['odontogram_is_draw']) {
            state.postData['odontogram_draw'] = state.canvas_odontogram.toDataURL("image/png");
        }
        // end

        // next konsul
        if (!state.postData['next_konsultasi']) {
            commit('setIsSaving', { key: 'is_next_konsul', value: false });
            return;
        }
        if (state.postData['tgl_next_konsultasi' === false]) {
            commit('setIsSaving', { key: 'is_next_konsul', value: false });
            return;
        }

        if (state.saving_params['is_email_format'] === false) {
            commit('setIsSaving', { key: 'is_email', value: false });
            return;
        }
        
        // process send to backend
        try {
            commit('setIsSaving', { key: 'is_saving', value: true });
            const res = await axios.post(
                "/rekam_medis",
                { ...state.postData }
            )
            const { status, message, bpjs, data, errResponseBPJS } = res.data
            commit('setIsSaving', { key: 'is_saving', value: false });
            // console.log(errResponseBPJS);
            commit('setErrorSyncMsg', errResponseBPJS)

            if (status) {
                if (bpjs && Object(bpjs).hasOwnProperty('add_kunjungan')) {
                    if (bpjs.add_kunjungan.metaData && [200, 201].includes(bpjs.add_kunjungan.metaData.code)) {
                        const dataKunjungan = bpjs.add_kunjungan.response.find((item) => item.field == 'noKunjungan');
                        commit('setPostData', { key: "noKunjungan", value: dataKunjungan.message || null });
                    }
                }

                localStorage.setItem("rekam_medis_id", data.rekam_medis.id)
                if(is_klinik) {
                    commit('setIsSaving', { key: 'is_saved', value: true });
                    commit('setIsSaving', { key: 'is_kuotanotnull', value: true });
                    await axios.put(
                        "/transaksi/" + transklinik_id, {
                        status: state.saving_params['is_selesai'] ? 'SELESAI' : 'KONSULTASI'
                    });
                    return res.data;
                } else {
                    commit('setIsSaving', { key: 'is_saved', value: true });
                    commit('setIsSaving', { key: 'is_kuotanotnull', value: true });
                    await axios.put(
                        "/transaksi/" + transklinik_id, {
                        status: 'SELESAI'
                    });
                    return res.data;
                }
            }

            if (message === "Qouta telah habis" || message === "Kuota telah habis") {
               commit('setIsSaving', { key: 'is_kuotanotnull', value: false });
               commit('setIsSaving', { key: 'is_saved', value: true });
            }
        } catch (err) {
            commit('setIsSaving', { key: 'is_saving', value: false });
        }
    },
};

const mutations = {
    resetState(state) {
        Object.assign(state, getDefaultState())
    },
    setPasien: (state, pasien) => (state.pasien = pasien.data),
    setTransaksi: (state, transData) => (state.transaksi = transData),
    setErrorSyncMsg: (state, message) => (state.errorSyncMsg = message),
    setOrgans: (state, organs) => (state.organs = organs.data.organ),
    setPostData: (state, payload) => {
        state.postData[payload.key] = payload.value;
    },
    editSetPostData: (state, payload) => {
        payload.map(item => {
            state.postData[item.key] = item.value
        })
    },
    setCanvas: (state, payload) => {
        if (payload.key === 'PEMERIKSAAN') {
            state.canvas_pemeriksaan = payload.value;
        }

        if (payload.key === 'DIAGNOSA') {
            state.canvas_diagnosa = payload.value;
        }

        if (payload.key === 'ANAMNESA') {
            state.canvas_anamnesa = payload.value;
        }

        if (payload.key === 'KELUHAN') {
            state.canvas_keluhan = payload.value;
        }

        if (payload.key === 'TATALAKSANA') {
            state.canvas_tatalaksana = payload.value;
        }

        if (payload.key === 'PEMERIKSAAN_PENUNJANG') {
            state.canvas_pemeriksaan_penunjang = payload.value;
        }

        if (payload.key === 'ODONTOGRAM') {
            state.canvas_odontogram = payload.value;
        }
    },
    setIsSaving: (state, payload) => {
        state.saving_params[payload.key] = payload.value;
    },
    setKesadaran: (state, payload) => {
        state.kesadaran[payload.key] = payload.value;
    },
    setStatusPulang: (state, payload) => {
        state.status_pulang[payload.key] = payload.value;
    },
    setPostDataLoaded: (state, payload) => (state.postDataLoaded = payload)
};

export default {
    state,
    getters,
    actions,
    mutations
};
